import { AppState } from './types';

export const getAppVersion = (state: AppState) => state.app.version;
export const getAppStep = (state: AppState) => state.app.step;
export const getAppSubStep = (state: AppState) => state.app.subStep;
export const getAppIsLoading = (state: AppState) => state.app.isLoading;
export const getAppBack = (state: AppState) => state.app.back;
export const getAppOfferDate = (state: AppState) => state.app.offerDate;
export const getAppExpiry = (state: AppState) => state.app.expiry;
export const getAppOfferId = (state: AppState) => state.app.offerId;

